import React from 'react';

function Header() {
  return (
    <header className="header">
      <div className="header-top">
        <div className="header-logo">
          <div className="header-logo-icon">FE</div>
          <h1>
            BESS Noise Assessment
            <small>ISO 9613-2 Screening Calculator</small>
          </h1>
        </div>
        <div className="header-brand">
          <a href="https://franceng.com" target="_blank" rel="noopener noreferrer">
            Franc Engineering
          </a>
        </div>
      </div>
      <div className="header-tagline">
        Free screening-level noise calculator for solar and BESS projects
      </div>
    </header>
  );
}

export default Header;
